import React from 'react';
import ActionButton from './ActionButton';

/**
 * Reusable button group component for tab action buttons
 */
const ActionButtonGroup = ({ children, style = {} }) => {
    return (
        <div style={{ marginBottom: '8px', ...style }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ActionButtonGroup;
export { ActionButton };

